import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { FloatingContactActions } from './components/FloatingContactActions';

import { HomePage } from './pages/HomePage';
import { ServicesIndexPage } from './pages/ServicesIndexPage';
import { ServiceDetailPage } from './pages/ServiceDetailPage';
import { CalculatorPage } from './pages/CalculatorPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { ReferencesPage } from './pages/ReferencesPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { ForbiddenPage } from './pages/ForbiddenPage';

export default function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col font-sans bg-[#E6EBEF] text-[#0B0E14] selection:bg-[#206FEA] selection:text-white">
        <Header />
        <FloatingContactActions />
        <main className="grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            
            {/* Ydelser Routes */}
            <Route path="/ydelser" element={<ServicesIndexPage />} />
            <Route path="/ydelser/:slug" element={<ServiceDetailPage />} />

            {/* Direct Service Aliases from Scrape URLs */}
            <Route path="/pillefyr" element={<Navigate to="/ydelser/pillefyr" replace />} />
            <Route path="/pillefyr-til-helaarshuse-og-erhverv-med-behov-for-stabil-varme" element={<Navigate to="/ydelser/pillefyr" replace />} />
            <Route path="/luft-til-luft-varmepumpe" element={<Navigate to="/ydelser/luft-til-luft-varmepumpe" replace />} />
            <Route path="/luft-til-vand-varmepumpe" element={<Navigate to="/ydelser/luft-til-vand-varmepumpe" replace />} />
            <Route path="/solceller" element={<Navigate to="/ydelser/solceller" replace />} />
            <Route path="/varmepumpe-service" element={<Navigate to="/ydelser/varmepumpe-service" replace />} />
            <Route path="/montage" element={<Navigate to="/ydelser/montage" replace />} />
            <Route path="/salg" element={<Navigate to="/ydelser/salg" replace />} />
            <Route path="/service" element={<Navigate to="/ydelser/service" replace />} />

            {/* Pages */}
            <Route path="/prisberegner" element={<CalculatorPage />} />
            <Route path="/om-os" element={<AboutPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/referencer" element={<ReferencesPage />} />
            <Route path="/produkter" element={<ReferencesPage />} />
            <Route path="/reference" element={<ReferencesPage />} />

            {/* Error Pages */}
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}
